module.exports = __webpack_public_path__ + "static/media/espacokids.74217bdf.png";